// COMPONENTS
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";
import { IconButton, TableCell } from "@mui/material";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
// UTILS/HOOKS
import { RoutesConstants } from "@/main/routes/routesConstants";
import SearchIcon from "@mui/icons-material/Search";

// UTILS/HOOKS
import { getTranslateByKey } from "@/main/services/utils";
import { SearchgridTemplateResponse } from "@/main/models/response/templateEmailNotificationCompanyResponse";

import * as S from "./styles";
import useKogControlElementId from "@/main/hooks/useKogControlElementId";
import { Controls } from "@/main/services/constants/constantsControl";

interface IRowEmailTemplateProps {
	emailTemplate: SearchgridTemplateResponse;
	openModalDetail: (item: SearchgridTemplateResponse) => void;
}

function RowEmailTemplate({ emailTemplate, openModalDetail }: IRowEmailTemplateProps) {
	const navigate = useNavigate();
	const showButtonEdit = useKogControlElementId(Controls.IdEditEmailTemplate);

	return (
		<KOGTableRow $notClickable key={emailTemplate.guidTemplateEmailNotificationCompany}>
			<TableCell width="15%">{emailTemplate.insurerName}</TableCell>
			<TableCell width="40%">{emailTemplate.subject}</TableCell>
			<TableCell width="25%">{emailTemplate.templateEmailNotificationName}</TableCell>
			<TableCell width="10%">{emailTemplate.systemName}</TableCell>
			<TableCell width="5%" align="center">
				<S.ActionButtons>
					<TooltipComponent title={`${getTranslateByKey("information.preview")}`}>
						<IconButton
							id={`id-emailTemplate-detail-${emailTemplate.guidTemplateEmailNotificationCompany}`}
							color="primary"
							onClick={() => openModalDetail(emailTemplate)}
						>
							<SearchIcon />
						</IconButton>
					</TooltipComponent>
					{showButtonEdit && (
						<TooltipComponent title={`${getTranslateByKey("information.editReportTemplate")}`}>
							<IconButton
								id={`id-emailTemplate-edit-${emailTemplate.guidTemplateEmailNotificationCompany}`}
								color="primary"
								onClick={() =>
									navigate(
										`${RoutesConstants.registrationRegisterEmailTemplate}?guidTemplate=${emailTemplate.guidTemplateEmailNotificationCompany}&idTemplateEmailNotification=${emailTemplate.idTemplateEmailNotification}&idSystemApplication=${emailTemplate.idSystemApplication}&guidCompany=${emailTemplate.guidCompany}`,
									)
								}
							>
								<EditIcon />
							</IconButton>
						</TooltipComponent>
					)}
				</S.ActionButtons>
			</TableCell>
		</KOGTableRow>
	);
}

export default RowEmailTemplate;
